// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__cC-JM","text":"style_text__Bgcwc"};